import * as mxp from './mxp';
import * as projects from './projects';

export default {
  mxp,
  projects,
};
